// extracted by mini-css-extract-plugin
export default {"root":"SendMessage_root__RfvyF"};